import { Theme } from 'styles/theme';

export const getEpdWizardCustomSelectStyles = (theme: Theme) => ({
  menu: (styles: any) => ({ ...styles }),
  control: (styles: any, state: any) => ({
    ...styles,
    borderRadius: '2px',
    color: 'black',
    fontSize: '14px',
    fontFamily: 'Inter',
    fontWeight: 400,
    lineHeight: 'normal',
    minHeight: '44px',
    borderColor: state.isFocused ? theme.colors.primaryOrange : theme.colors.elementsInputBorder,
    outline: state.isFocused ? `2px solid ${theme.colors.primaryOrange}` : '',
    '&:hover': {
      borderColor: theme.colors.primaryOrange,
    },
  }),
  multiValueLabel: (styles: any) => ({
    ...styles,
    fontSize: '100%',
  }),
});
